import { render, staticRenderFns } from "./addPopup.vue?vue&type=template&id=b8c5a6fe&"
import script from "./addPopup.vue?vue&type=script&lang=js&"
export * from "./addPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports